export default {
  labels: {
    selectOne: 'Seleciona uma opção',
    selectAll: 'Seleciona todas as que se aplicam',
    typeResponse: 'Escreve a tua resposta na caixa de texto abaixo.',
    recordResponse: 'Faça uma gravação para responder à pergunta.',
    enterNumeric: 'Introduz uma resposta numérica no campo abaixo.',
    rateResponseScale: 'Avalia a tua resposta na escala fornecida.',
    sliderMinimum: 'Valor mínimo: {value}',
    sliderMaximum: 'Valor máximo: {value}',
    selectOneOptionRow: 'Seleciona uma opção em cada linha.',
    selectAllOptionsRow: 'Seleciona todas as opções que se aplicam para cada linha.',
    dragAndDropResponse: 'Arrasta e larga as opções para as ordenar por preferência.',
    rankOrderDesktopInstruction: 'Arraste e largue itens para os classificar, ou use o botão + para adicionar um item à lista. Use os botões de seta para reordenar ou o botão de eliminar para remover um item.',
    alert: "Alerta",
    error: 'Por favor, insira um número entre {min} e {max}.',
    cameras: 'Câmaras',
    microphones: 'Microfones',
    recording: 'Gravação',
    noDevicesFound: 'Nenhum dispositivo encontrado',
    camera: 'Câmara',
    microphone: 'Microfone',
    stopRecording: 'Parar gravação',
    startRecording: 'Iniciar gravação',
    disableCamera: 'Desativar câmara',
    enableCamera: 'Ativar câmara',
    disableMicrophone: 'Desativar microfone',
    enableMicrophone: 'Ativar microfone',
    settings: 'Definições',
    recordingProgress: 'Progresso da gravação',
    playbackProgress: 'Progresso da reprodução',
    play: 'Reproduzir',
    pause: 'Pausar',
    stop: 'Parar',
    record: 'Gravar',
    recordAgain: 'Gravar novamente',
    retry: 'Tentar novamente',
    done: 'Concluir',
    minRecordTime: 'Por favor, grave uma resposta por {min} segundos.',
    enlargeImage: 'Ampliar imagem',
    enlargedImage: 'Imagem ampliada',
    close: 'Fechar',
    zoomIn: 'Aumentar zoom',
    zoomOut: 'Diminuir zoom',
    resetZoom: 'Repor zoom',
    zoomLevel: 'Zoom {percentage}%',
    imagePosition: '{current} de {total}',
    previousImage: 'Imagem anterior',
    nextImage: 'Imagem seguinte',
    imageLoading: 'A carregar imagem',
    imageLoadFailed: 'Não foi possível carregar a imagem',
  },
  noSelection: "Nenhuma seleção",
  actions: {
    increase: 'Aumentar',
    decrease: 'Diminuir'
  },
  survey: {
    endOfSurvey: {
      titleTerminated: 'Pré-visualização do Inquérito Terminada',
      titleCompleted: 'Pré-visualização do Inquérito Concluída',
      previewModeWarning: 'Esta página só é visível no Modo de Pré-visualização e não será mostrada aos inquiridos reais.',
      reachedEndPoint: 'Este inquérito chegou a um ponto final.',
      reachedEndPointCompleted: 'Esta pré-visualização chegou a um ponto final.',
      returnToModify: 'Volte à pergunta anterior para modificar as suas respostas e testar um percurso de inquérito diferente.',
      logic: 'Lógica'
    }
  }
}
